/**
 * Clean wiki Q&A markdown before rendering.
 * Long prose lines must be kept: dropping them made answers look empty.
 */
export function sanitizeQaWikiAnswer(text, ragId) {
  if (!text) return text;
  if (String(ragId).toLowerCase() !== "wiki") {
    return String(text);
  }

  let t = String(text);
  t = t.replace(/\n*#{2,6}\s*Section:\s*[\s\S]*?(?=\n#{2,6}|$)/gi, "");
  t = t.replace(/\|{2,}/g, "");
  return t.trim();
}
